
export default function TrainingApproachSection() {
  const steps = [
    {
      number: 1,
      icon: 'ri-search-line',
      title: 'Needs Assessment',
      description: 'We conduct a comprehensive analysis of your organisation\'s training requirements and skill gaps.'
    },
    {
      number: 2,
      icon: 'ri-file-text-line',
      title: 'Custom Design',
      description: 'Our experts design tailored training programmes that align with your business objectives.'
    },
    {
      number: 3,
      icon: 'ri-calendar-line',
      title: 'Flexible Delivery',
      description: 'Choose from on-site, virtual, or blended learning options that fit your schedule.'
    },
    {
      number: 4,
      icon: 'ri-presentation-line',
      title: 'Expert Facilitation',
      description: 'Experienced facilitators deliver engaging, interactive training sessions.'
    },
    {
      number: 5,
      icon: 'ri-bar-chart-line',
      title: 'Results Measurement',
      description: 'We track progress and measure the impact of training on your business performance.'
    }
  ];

  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Our Corporate Training Approach
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A proven 5-step methodology that ensures your training investment delivers real business results
          </p>
        </div>

        <div className="relative">
          {/* Desktop Grid */}
          <div className="hidden lg:grid grid-cols-5 gap-6 items-stretch">
            {steps.map((step, index) => (
              <div key={step.number} className="flex flex-col items-center">
                {/* Icon with connecting lines */}
                <div className="relative w-full flex justify-center mb-4">
                  {index > 0 && (
                    <div className="absolute top-1/2 right-[calc(50%+2.5rem)] left-0 h-px bg-[#2D7F3E]/30 -translate-y-1/2" />
                  )}
                  {index < steps.length - 1 && (
                    <div className="absolute top-1/2 left-[calc(50%+2.5rem)] right-0 h-px bg-[#2D7F3E]/30 -translate-y-1/2" />
                  )}
                  <div className="w-16 h-16 bg-[#2D7F3E] rounded-full flex items-center justify-center relative z-10 flex-shrink-0">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                {/* Card — flex-1 so all cards fill remaining height equally */}
                <div className="bg-white rounded-lg p-6 shadow-lg w-full flex flex-col flex-1 text-center">
                  <div className="w-8 h-8 bg-[#2D7F3E] rounded-full flex items-center justify-center text-white font-bold text-sm mb-3 mx-auto flex-shrink-0">
                    {step.number}
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-sm text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile Stack */}
          <div className="lg:hidden space-y-6">
            {steps.map((step) => (
              <div key={step.number} className="bg-white rounded-lg p-6 shadow-lg">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#2D7F3E] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center mb-2">
                      <div className="w-6 h-6 bg-[#2D7F3E] rounded-full flex items-center justify-center text-white font-bold text-xs mr-3">
                        {step.number}
                      </div>
                      <h3 className="font-semibold text-gray-900">{step.title}</h3>
                    </div>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}